export default __webpack_public_path__ + "static/media/proj14-cover.a3676931.png";